module.exports = __webpack_public_path__ + "static/media/Beru Whitesun lars.1583dc84.jpg";